import { useFeatureToggle } from '@/context/featureToggles'
import { SeriesClassesRowSection } from '@/shared/api-generated-types'
import React from 'react'
import ClassCardRow from '../ClassCardRow'

export interface Props extends Partial<SeriesClassesRowSection> {}

const SeriesClassesRowBlock = ({ ...props }: Props): JSX.Element | null => {
  const isVodHomepage = useFeatureToggle('vod_homepage')
  if (!props.items?.length) return null
  if (props.id === 'vod-homepage' && !isVodHomepage) return null
  const items = props.items?.map((item) => {
    return {
      ...item,
      start: item.upcomingSession?.start,
      isCommunityLedClass: item.upcomingSession?.isCommunityLedClass,
      isEncore: item.upcomingSession?.isEncore,
      end: item.upcomingSession?.end,
      title: item.upcomingSession?.title,
      sessionId: item.upcomingSession?.sessionId,
      sponsor: item.upcomingSession?.sponsor,
      vodClass: props.id === 'vod-homepage',
    }
  })

  return (
    <ClassCardRow
      items={items}
      title={props.title}
      navigationActions={props.navigationActions}
      carousel="always"
      theme="white"
    />
  )
}
export default React.memo(SeriesClassesRowBlock)
